import { restore, sample } from 'effector';
import { t } from 'i18n';
import { $additionalProducts } from 'models/additional-products';
import $$i18n from 'models/i18n';

import { opposite } from 'utils/common-helper';

sample({
    source: $additionalProducts,
    clock: restore($$i18n.localesLoaded.map(Boolean).map(opposite), false),
    fn: (additionalProducts) => ({
        ...additionalProducts,
        giftTrust: (t('features.giftTrustMenuItem') as unknown) === true,
    }),
    target: $additionalProducts,
});
